import React, {useState, useEffect} from 'react';
import './Home.css';
import axios from 'axios';
import { domain } from '../variables';
import BoxChamp from '../components/BoxChamp';
import BoxPlayOff from '../components/BoxPlayOff';
import BoxLivescoring from '../components/BoxLivescoring';
import Carrousel from '../components/Carrousel';

function Home() {
    const [actus, setActus] = useState([]);
    const [video, setVideo] = useState(null);
    const [matchsLivescoring, setMatchsLivescoring] = useState(null);
    const [currentItemCaroussel, setCurrentItemCaroussel] = useState(0);
    const LENGTH_CAROUSSEL = 10;

    // Activer l'affichage des playoff / playdown sur le site.
    const playOffDownVisble = false;
    const playOffProAVisible = false;

    useEffect(() => {
        if (video == null) {
            getLastVideoFFTT()
        }
        getMatchLivescoring()
    }, [])

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (currentItemCaroussel >= LENGTH_CAROUSSEL-1) {
                setCurrentItemCaroussel(0);
            }
            else {
                setCurrentItemCaroussel(currentItemCaroussel+1)
            }
        }, 3000)
        
        if (actus.length === 0) {
            getActus();
        }   

        return () => clearTimeout(timeout);
    }, [currentItemCaroussel])

    const getActus = async () => {
        const link = domain + '/server/getActualites.php';
        await axios.post(
            link, 
            {
                tag: 4,
                offset: 0,
                limit: LENGTH_CAROUSSEL,
            }
        ).then(res => {
            const data = res.data;
            setActus(data);
        })
    }

    const getMatchLivescoring = async () => {
        const link = 'https://fftt.dafunker.com/livescore/directs_with_dates';
        await axios.get(
            link, 
            {
                params: {
                    // date: "19/09/2023"
                    // on récupère les matchs d'aujourd'hui
                    date: new Date().toLocaleDateString('fr-FR')
                }
            }
        ).then(res => {
            const data = res.data;
            setMatchsLivescoring(data);
        })
    }

    // Fonction pour récupérer le nom du championnat grâce au TAG livescoring
    const getChampionnatByTags = (tags) => {
        switch (tags[0]) {
            case "PRO A":
                if (tags[1] === "MESSIEURS") {
                    return 'proam';
                } 
                else {
                    return 'proad';
                }
            case "PRO B":
                if (tags[1] === "MESSIEURS") {
                    return 'probm';
                } 
                else {
                    return 'probd';
                }
            default:
                return null;
        }
    }

    const goToActus = (actu) => {
        window.open(actu, "_blank");
    }

    const getLastVideoFFTT = async () => {
        // const link = "https://www.googleapis.com/youtube/v3/search?key="+API_KEY+"&channelId="+CHANNEL_ID+"&part=snippet,id&type=video&videoDuration=short&order=date&maxResults=1";
        const link = domain + '/server/getVideos.php'
        await axios.post(
            link,
            {
                type: 'last',
                limit: 1,
            }
        ).then(res => {
            const data = res.data;
            setVideo(data.items[0]);
        })
    }

    return ( 
        <div className="home_page">
            <div className="caroussel">
                {
                    actus.map((item, index) => {
                        return (
                            <div 
                                key={index} 
                                className="caroussel_item"
                                style={{transform: `translate(-${currentItemCaroussel * 100}%)`}}
                            >
                                <img 
                                    src={item.news_medias_picture} 
                                    alt=""
                                    style={{cursor: 'pointer'}}
                                    onClick={()=>goToActus(item.pages_fr_slug)}
                                />
                                <div className="caroussel_content">
                                    <div className="line" style={{width: 100}}></div>
                                    <span className="caroussel_title">
                                        {item.news_title}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
                <div className="caroussel_point_container">
                    {
                        actus.map((item, index) => {
                            return (
                                <div 
                                    key={index} 
                                    className={currentItemCaroussel === index ? "caroussel_point active" : "caroussel_point"}
                                    onClick={()=>setCurrentItemCaroussel(index)}
                                >
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {/* Compartiment pour afficher les matchs du livescoring */}
            <div className="under_caroussel">
                <Carrousel showPagination interval={3000} automatic>
                    {
                        matchsLivescoring !== null &&
                        matchsLivescoring.dates.find(item => item.index === 0).groups.map((group) => {
                            return (
                                // on affiche chaque match de la date en cours
                                group.matchs.length > 0 &&
                                group.matchs.map((match, index) => {
                                    return (
                                        <BoxLivescoring 
                                            key={index} 
                                            match={match}
                                            championnat={getChampionnatByTags(group.tags)}
                                        />
                                    )
                                })
                            )
                        })
                    }
                </Carrousel>
            </div>


            <div className="home_content">         
                {
                    (playOffDownVisble == true) &&
                    <>
                        {
                            (playOffProAVisible == true) &&
                            <>
                                <BoxPlayOff championnat='proam' />
                            </>  
                        }
                        {
                            (playOffProAVisible == false) &&
                            <>
                                <BoxChamp championnat='proam' />
                            </>
                        }
                        <BoxPlayOff championnat='proad' />
                        <BoxPlayOff championnat='probm' />
                        <BoxChamp championnat='probd' />  
                    </>
                }
                {
                    (playOffDownVisble == false) &&
                    <>
                        <BoxChamp championnat='proam' />
                        <BoxChamp championnat='proad' />
                        <BoxChamp championnat='probm' />
                        <BoxChamp championnat='probd' />   
                    </>
                }     
                {/*{
                    video !== null &&
                    <BoxVideo title={video.snippet.title} description={video.snippet.description} embed={video.snippet.resourceId.videoId} />
                } */}
                <iframe title="video" width="560" height="315" src="https://www.youtube.com/embed/DiRjuLAOWEU?autoplay=1&origin=http://fftt.com/pro" 
                    allowFullScreen="allowfullscreen"
                    mozallowfullscreen="mozallowfullscreen" 
                    msallowfullscreen="msallowfullscreen" 
                    oallowfullscreen="oallowfullscreen" 
                    webkitallowfullscreen="webkitallowfullscreen"> 
                </iframe> 
            </div>

            {/* <div className="home_maintenance">
                <h1>Site en maintenance</h1>
                <h3>Le site subit des modifications en prévision de la prochaine saison 2023-2024</h3>
            </div> */}
        </div>
    );
}

export default Home;